// extracted by mini-css-extract-plugin
export var content = "_e7-3";
export var list = "_e7-4";
export var settingsContent = "_e7-7";
export var settingsPanel = "_e7-8";
export var state = "_e7-6";
export var triggerBadge = "_e7-2";
export var triggerButton = "_e7-1";
export var triggerShell = "_e7-0";
export var unreadDot = "_e7-5";